module.exports = __webpack_public_path__ + "media/images/new-ui-images/icon-3-4b8d93705d6dfacd1d5f1985836e066d.svg";